import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        
          <Link className="navbar-brand" to="/">
          <div className="brand-container">
            <img src="/assets/logo.png" alt="AJ Drones Logo" className="brand-logo-image" />
            <div className="brand-text-container">
              <span className="brand-text">AJ Drones</span>
              <span className="brand-tagline">Innovating the Skies</span>
            </div>
          </div>
        </Link>
        
      
          
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/') || isActive('/home') ? 'active' : ''}`} to="/" onClick={() => setIsMobileMenuOpen(false)}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/services') ? 'active' : ''}`} to="/services" onClick={() => setIsMobileMenuOpen(false)}>
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/workshops') ? 'active' : ''}`} to="/workshops" onClick={() => setIsMobileMenuOpen(false)}>
                Workshops
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/about') ? 'active' : ''}`} to="/about" onClick={() => setIsMobileMenuOpen(false)}>
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/contact') ? 'active' : ''}`} to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                Contact
              </Link>
            </li>
           
            <li className="nav-item">
              <Link to="/contact" className="btn btn-workshop" onClick={() => setIsMobileMenuOpen(false)}>
                Book Workshop
              </Link>
            </li>

          </ul>
         
        </div>
        <button className="btn btn-theme-toggle" onClick={toggleTheme} >
                {theme === 'dark' ? '☀️' : '🌙'}
              </button>
        </div>
      
    </nav>
  );
};

export default Navigation;

